module.exports = __webpack_public_path__ + "static/media/31-10.7a96238d.mp3";